$(document).ready(function() {

    $('#quickfilter').on('keyup', function() {
        const that = this,
            $allListElements = $('.o-list > li');

        const $matchingListElements = $allListElements.filter(function(i, li) {
            const listItemText = $(li)
                    .text()
                    .toUpperCase(),
                searchText = that.value.toUpperCase();

            return ~listItemText.indexOf(searchText);
        });

        $allListElements.hide();
        $matchingListElements.show();
    });

    $('#quickfilter-height-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $(this)
            .toggleClass('open')
            .prev()
            .find('.filter-options-content-categories')
            .toggleClass('filter-options-content-categories-fixed-height');
    });
});
